import React from 'react';

const About = () => {

    return (
        <>
            <section id="container" className="wrap">
                <div className="paragraph">
                    <h1 className="subject"><strong>SKYTONE</strong></h1> 
                    <h2 className="title">소개</h2>
                    <p className="title-dc">오늘의 공기는 어떤 색일까요?<br/>하늘을 닮은 작은 액자, SKYTONE을 소개합니다.</p>
                    <div className="screenshot">
                        <img src={process.env.PUBLIC_URL + '/skytone_src/about-01.png'} alt=""/>
                    </div>       
                    <article className="sub-paragraph">            
                        <h3 className="subject"><strong>SKYTONE은</strong></h3>
                        <p className="desc">한국환경공단에서 발표하는 지역별 대기오염 지수를 실시간으로 수집하여 보여주는 스마트한 데스크테리어 용품입니다.<br/>USB만 연결하면 바로 사용할 수 있으며, 어느 공간에나 어울리는 액자 형태를 하고 있습니다.</p>        
                        <div className="screenshot">
                            <img src={process.env.PUBLIC_URL + '/skytone_src/about-02.png'} alt=""/>
                        </div>       
                    </article>
                    <article className="sub-paragraph">            
                        <h3 className="subject">색으로 보는 공기질</h3>
                        <p className="desc">3개의 LED는 각각 ※통합대기환경지수(CAI), 미세먼지(PM10), 초미세먼지(PM2.5)에 대한 정보를 알고리즘을 통해 색상으로 시각화합니다.</p>        
                        <div className="screenshot">
                            <img src={process.env.PUBLIC_URL + '/skytone_src/about-03.png'} alt=""/>
                            <div className="label-row">
                                <span>CAI</span>
                                <span>PM10</span>
                                <span>PM2.5</span>
                            </div>
                            <div className="label-col">
                                <span>GOOD</span>
                                <span>BAD</span>
                            </div>
                        </div>       
                    </article>
                    <article className="reference">            
                        <p className="desc">
                            ※ 통합대기환경지수란?<br/>
                            6개의 주요 대기오염물질(아황산가스, 일산화탄소, 오존, 이산화질소, 미세먼지, 초미세먼지)의 대기오염 영향을 종합해 하나의 지수로 나타낸 수치입니다.
                        </p>
                        <div className="formula-wrap">
                            <p className="formula">
                                I<sub>p</sub> = <span className="fraction">
                                <span className="numerator">I<sub>HI</sub> - I<sub>LO</sub></span>
                                <span className="denominator">BP<sub>HI</sub> - BP<sub>LO</sub></span>
                                </span> × (C<sub>P</sub> - BP<sub>LO</sub>) + I<sub>LO</sub>
                            </p>
                            <ul className="formula-note">
                                <li><span>I<sub>p</sub> = </span>대상 오염물질의 대기지수 점수</li>
                                <li><span>C<sub>p</sub> = </span>대상 오염물질의 대기중 농도</li>
                                <li><span>BP<sub>HI</sub> = </span>대상 오염물질의 오염도 해당 구간에 대한 최고 오염도</li>
                                <li><span>BP<sub>LO</sub> = </span>대상 오염물질의 오염도 해당 구간에 대한 최저 오염도</li>
                                <li><span>I<sub>HI</sub> = BP<sub>HI</sub></span>에 해당하는 지수값(구간 최고 지수값)</li>
                                <li><span>I<sub>LO</sub> = BP<sub>LO</sub></span>에 해당하는 지수값(구간 최저 지수값)</li>
                            </ul>
                            <p className="source">&lt;출처 : 에어코리아&gt;</p>
                        </div>
                    </article>
                    <article className="sub-paragraph">        
                        <div className="screenshot">
                            <img src={process.env.PUBLIC_URL + '/skytone_src/about-05.png'} alt=""/>
                        </div>    
                        <h3 className="subject">삶의 질을 높이는 <span className="dfont">LIFEHACK</span></h3>
                        <p className="desc">
                            SKYTONE은 현대적인 디자인의 조명으로, 실시간 대기질 정보를 직관적으로 제공합니다. 조명의 색상 변화를 통해 오늘의 공기를 한눈에 확인할 수 있어, 외출 준비에도 유용합니다.
                            <br/><br/>만약 하늘이 맑다면, 망설이지 말고 바로 밖으로 나가보세요. 일상의 작은 변화를 통해 쾌적한 생활 환경을 유지하고, 이를 통해 삶의 질을 지속적으로 관리할 수 있습니다.
                        </p>  
                    </article>
                    <hr className="empty-space"/>
                    <article className="sub-paragraph">        
                        <div className="screenshot">
                            <img src={process.env.PUBLIC_URL + '/skytone_src/about-06.png'} alt=""/>
                        </div>    
                        <h3 className="subject"><span className="dfont">DIGICRAFT</span></h3>
                        <p className="desc">우리는 디지털 기술과 수작업을 결합한 자체 공정, "디지크래프트"를 통해 제품을 제작합니다. 이 과정은 디지털과 아날로그의 조화로운 결합을 추구하고, 제품을 사용자가 직접 제작함으로써 고유하고 특별한 경험을 제공합니다.</p>
                        <p className="desc">전자부품을 연결하고 동봉된 육각렌치를 이용해 나사만 고정하면 완성될 정도로 쉽게 조립할 수 있으며, 네트워크 연결 후 지역만 설정하시면 바로 사용 가능합니다.</p>
                        <p className="desc">Dafthings만의 수작업 공정을 거쳐 손수 빚어낸 조립 키트에 여러분의 손길을 더해 최첨단 전자기기로 완성해보세요 :)</p>
                    </article>
                </div>   
            </section>
        </>
    );
};

export default About;